import MuiGrid from "./MuiGrid";
import MuiTypography from "./MuiTypography";
import MuiFormHelperText from "./MuiFormHelperText";
import MuiListItemText from "./MuiListItemText";
import MuiTab from "./MuiTab";
import MuiTabs from "./MuiTabs";

export default {
  MuiGrid,
  MuiTypography,
  MuiFormHelperText,
  MuiListItemText,
  MuiTab,
  MuiTabs,
};
